import "./provider-search.scss";

const marker_icon_slected = "/wp-content/uploads/2024/06/marker-selected.svg";
const marker_icon = "/wp-content/uploads/2024/06/pin.svg";
const cluster_icon = "/wp-content/uploads/2024/06/cluster-1.svg";
const cluster_icon_has_selected =
  "/wp-content/uploads/2024/06/cluster_selected.svg";
const PER_PAGE = 9;
const DEFAULT_LAT = 39.8283; // Center of USA latitude
const DEFAULT_LNG = -98.5795; // Center of USA longitude
const DEFAULT_ZOOM = 4; // Zoom level to show continental US
var lastSearched = false;
var jobTybe = "any";
var allProviders = [];
var totalProviders = 0;
var current_search = false;
var distance_bias = 20;
var result_distance = 100;
var result_distance_miles = 60;
var user_interaction = false;
var dynamicRadiusEnabled = true; // Flag to enable/disable dynamic radius feature
var zoomDebounceTimer = null; // Timer for debouncing zoom events
var isZooming = false; // Flag to track active zooming
var lastProcessedZoom = null; // Track last zoom level that was fully processed
var programmaticMapMove = false; // Flag to track programmatic map movements

// Global variable to track whether we're using US units
var isUsingUSUnits = false;

window.allProviders = allProviders;
var hasMapView = false;

// Add after the initial variable declarations
var searchState = {
  lat: null,
  lng: null,
  zoom: null,
  searchTerm: "",
  selectedProvider: null
};

jQuery(document).ready(function ($) {
  // get map query var from url
  const urlParams = new URLSearchParams(window.location.search);
  const map = urlParams.get("map");
  if (map) {
    hasMapView = true;
  }

  result_distance = parseInt($("#result-distance-km").text());
  result_distance_miles = parseInt($("#result-distance-miles").text());

  console.log("result_distance", result_distance);
  console.log("result_distance_miles", result_distance_miles);

  const distance_tag_value = $("#distance-bias").text();
  var viewMoreButton = $("#view-more");
  if (distance_tag_value) {
    distance_bias = parseInt(distance_tag_value);
  }
  $(".toggle button").click(function () {
    var $this = $(this);
    var id = $this.attr("id");
    $("#provider-search").removeClass("list-view map-view");

    $("#provider-search").addClass(id);

    $(".toggle button").removeClass("active");
    $this.addClass("active");

    // If switching to list view, reset distance to default 160km
    if (id === "list-view") {
      result_distance = 160;
      result_distance_miles = roundToNearest5(
        Math.round(result_distance * 0.621371)
      ); // Convert km to miles and round to nearest 5

      // Update the distance display using the central function
      updateDistanceText();

      // Redraw the search circle with the new distance
      if (map && current_search) {
        drawSearchCircle(
          current_search.lat,
          current_search.lng,
          result_distance,
          true
        );
      }

      // Re-sort providers with the new distance
      if (current_search) {
        sortListByDistance(current_search.lat, current_search.lng);
      }
    }

    // set the cookie
    Cookies.set("provider_search_view", id, {
      expires: 7
    });
  });

  // Load the view from the cookie
  const view = Cookies.get("provider_search_view");

  if (view) {
    $("#provider-search").removeClass("list-view map-view");
    $("#provider-search").addClass(view);
    $(".toggle button").removeClass("active");
    $(`.toggle button#${view}`).addClass("active");
  }

  // Check for search state in URL and restore if present
  if (window.location.search) {
    restoreSearchState();
  }

  // Initialize with current URL state if present
  if (urlParams.has("map_lat") && urlParams.has("map_lng")) {
    // Create initial history state
    const initialState = {
      lat: parseFloat(urlParams.get("map_lat")),
      lng: parseFloat(urlParams.get("map_lng")),
      zoom: urlParams.has("map_zoom")
        ? parseInt(urlParams.get("map_zoom"))
        : null,
      searchTerm: urlParams.get("map_search") || "",
      selectedProvider: urlParams.get("map_provider") || null
    };

    // Replace current history state
    window.history.replaceState(initialState, "", window.location.href);

    // Restore the state
    restoreSearchState();
  }
});

(function ($) {
  var mapMarkers = [];

  let cluster;
  let map;
  let selected = false;
  let zoom = 5;

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  function setZoom(zoomLevel) {
    // Don't process if we're already at this zoom level
    if (zoom === zoomLevel) return;

    isZooming = true;
    map.setZoom(zoomLevel);
    zoom = zoomLevel;

    // Clear any existing timer
    if (zoomDebounceTimer) {
      clearTimeout(zoomDebounceTimer);
    }

    // Update search radius based on new zoom level if dynamic radius is enabled
    if (dynamicRadiusEnabled && current_search) {
      // Hide the circle during zooming
      if (currentSearchCircle) {
        currentSearchCircle.setMap(null);
        currentSearchCircle = null;
      }

      const newRadius = calculateRadiusFromZoom(zoomLevel);

      // Delay the actual data update until zooming stops
      zoomDebounceTimer = setTimeout(() => {
        isZooming = false;
        result_distance = newRadius;
        result_distance_miles = roundToNearest5(
          Math.round(newRadius * 0.621371)
        ); // Convert km to miles and round to nearest 5

        // Defer UI updates to separate frames for smoothness
        requestAnimationFrame(() => {
          // Update distance text in the UI
          updateDistanceText();

          // Set loading indicator
          setLoading(true);

          // Use another timeout to give the browser time to render UI changes
          setTimeout(() => {
            // Re-run the search with the new radius
            sortListByDistance(current_search.lat, current_search.lng, true);

            // Update marker visibility based on new radius
            hideOutsideDistanceProvidersMarkers();

            // Draw the circle with the final radius only after everything is done
            drawSearchCircle(
              current_search.lat,
              current_search.lng,
              result_distance,
              true
            );

            setLoading(false);
          }, 50);
        });
      }, 750); // Increased debounce time to 750ms for more stable behavior
    }
  }

  function calculateRadiusFromZoom(zoomLevel) {
    // Define zoom-to-radius mapping (can be adjusted as needed)
    // Lower zoom = larger radius, Higher zoom = smaller radius
    const zoomRadiusMap = {
      4: 1000, // Country level - 1000km
      5: 750, // Large region
      6: 350, // Region
      7: 250, // Sub-region
      8: 160, // Large area
      // 9: 160, // Area
      // 10: 160, // Sub-area
      // 11: 160, // Default - City level
      12: 100 // Large neighborhood
    };

    // Clamp zoom level to valid range
    const clampedZoom = Math.min(Math.max(zoomLevel, 4), 18);

    // Find the closest zoom level in our map
    const availableZooms = Object.keys(zoomRadiusMap).map(Number);
    const closestZoom = availableZooms.reduce((prev, curr) =>
      Math.abs(curr - clampedZoom) < Math.abs(prev - clampedZoom) ? curr : prev
    );

    return zoomRadiusMap[closestZoom];
  }

  function updateDistanceText() {
    // Check if we're in US (miles) or elsewhere (km)
    // First check the search input
    const searchValue = $("#search-input").val() || "";
    const isUS =
      searchValue.includes("United States") ||
      searchValue.includes("USA") ||
      isUsingUSUnits;

    // Update the global tracker
    isUsingUSUnits = isUS;

    // Format with correct spacing and full unit names
    if (isUS) {
      $(".distance-text").text(result_distance_miles + " miles");
    } else {
      $(".distance-text").text(result_distance + " km");
    }
  }

  $("#search-form").submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    // Skip calculation if any parameter is invalid
    if (!lat1 || !lon1 || !lat2 || !lon2) return Infinity;

    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  function refreshClosestLocation() {
    // Loop through all provider cards in the DOM
    $(".provider-card").each(function () {
      const provider = $(this);
      const providerId = provider.data("provider");
      const mainLocationAddress =
        $(this).data("mainlocation") ||
        provider.attr("data-mainlocation") ||
        "Main Location";

      // Find the corresponding DOM element in allProviders array
      const providerElement = Array.from(allProviders).find(
        (p) => p.dataset.provider === providerId
      );

      if (providerElement && providerElement.closestLocation) {
        // Update the jQuery data attribute to match the dataset
        // Need to set the raw data to ensure it's not cached
        $.data(this, "closestlocation", providerElement.closestLocation);

        // Use the main location address if the closest location is the main location
        const displayAddress = providerElement.closestLocation.isMainLocation
          ? mainLocationAddress
          : providerElement.closestLocation.address;

        // Update the text display for the closest-location span only
        provider.find(".closest-location").text(displayAddress);
      } else if (providerElement && providerElement.dataset.closestlocation) {
        // If we have a closest location in the dataset but not in the element object
        try {
          const closestLocationData = JSON.parse(
            providerElement.dataset.closestlocation
          );
          if (closestLocationData) {
            // Ensure jQuery data is updated from the dataset
            $.data(this, "closestlocation", closestLocationData);

            // Use the main location address if it's the main location
            const displayAddress = closestLocationData.isMainLocation
              ? mainLocationAddress
              : closestLocationData.address;

            // Update only the closest-location span
            provider.find(".closest-location").text(displayAddress);
          }
        } catch (e) {
          console.log("Error parsing closest location data", e);
        }
      }
    });
  }
  let currentSearchCircle = null;

  window.refreshClosestLocation = refreshClosestLocation;

  function drawSearchCircle(lat, lng, radiusInKm, visible = true) {
    // Convert km to meters
    const radiusInMeters = radiusInKm * 1000;

    // Clear the previous circle if it exists
    if (currentSearchCircle) {
      currentSearchCircle.setMap(null); // Removes the circle from the map
      currentSearchCircle = null;
    }

    // Create a new circle only if visible is true
    if (visible) {
      currentSearchCircle = new google.maps.Circle({
        strokeColor: "#449ad8", // Border color
        strokeOpacity: 0.5, // Border opacity
        strokeWeight: 2, // Border thickness
        fillColor: "#449ad8", // Fill color
        fillOpacity: 0.03, // Fill opacity
        map: map, // Attach to your map instance
        center: { lat: lat, lng: lng }, // Center of the circle
        radius: radiusInMeters // Radius in meters
      });
    }
  }

  function sortListByDistance(lat, lng, dontScroll = false) {
    // Check if in list view - if so, always set distance to 160km
    const isListView = $("#provider-search").hasClass("list-view");
    if (isListView) {
      result_distance = 160;
      result_distance_miles = roundToNearest5(
        Math.round(result_distance * 0.621371)
      ); // Convert km to miles and round to nearest 5

      // Update the distance display
      updateDistanceText();
    }

    // Only clear selection if the map move was user-initiated (not programmatic)
    if (
      current_search &&
      !programmaticMapMove &&
      (Math.abs(current_search.lat - lat) > 0.0001 ||
        Math.abs(current_search.lng - lng) > 0.0001)
    ) {
      clearSelection();
    }

    current_search = { lat, lng };
    setLoading(true);
    var count_within_distance = 0;

    // Only draw the search circle if we're not in the middle of zooming
    if (!isZooming) {
      drawSearchCircle(lat, lng, result_distance, true);
    }

    const list = document.getElementById("providers");

    allProviders.forEach((provider) => {
      // console.log("Provider:", provider);
      const providerLat = provider.dataset.lat;
      const providerLng = provider.dataset.lng;

      // Get the main location address from the data-mainlocation attribute
      const mainLocationAddress =
        provider.dataset.mainlocation || "Main Location";

      // Calculate distance to the main location
      var distance = getDistanceFromLatLonInKm(
        lat,
        lng,
        providerLat,
        providerLng
      );

      // Initialize closestLocation with the main location data
      var closestLocation = {
        lat: providerLat,
        lng: providerLng,
        address: mainLocationAddress,
        isMainLocation: true // Flag to identify this is the main location
      };

      const additional_locations = provider.dataset.additionallocations;

      if (additional_locations) {
        const locations = JSON.parse(additional_locations);

        locations.forEach((location) => {
          const locationLat = location.lat;
          const locationLng = location.lng;

          const locationDistance = getDistanceFromLatLonInKm(
            lat,
            lng,
            locationLat,
            locationLng
          );

          if (locationDistance < distance) {
            distance = locationDistance;
            closestLocation = location;
            closestLocation.isMainLocation = false; // Mark as not the main location
          }
        });
      }

      // At this point, closestLocation is either the main location or the closest additional location
      if (closestLocation) {
        provider.closestLocation = closestLocation;

        // Update the dataset attribute
        provider.dataset.closestlocation = JSON.stringify(closestLocation);

        // Get the actual DOM element for the provider card and update it directly
        const providerCard = document.querySelector(
          `.provider-card[data-provider="${provider.dataset.provider}"]`
        );

        if (providerCard) {
          // Update the dataset on the DOM element
          providerCard.dataset.closestlocation =
            JSON.stringify(closestLocation);

          // Update the jQuery data - bypass cache by using $.data directly
          $.data(providerCard, "closestlocation", closestLocation);

          // Update ONLY the closest-location span for display
          const closestLocationElement =
            providerCard.querySelector(".closest-location");
          if (closestLocationElement) {
            // Use the actual address depending on if it's main location or not
            const displayAddress = closestLocation.isMainLocation
              ? mainLocationAddress
              : closestLocation.address;

            closestLocationElement.innerHTML = displayAddress;
          }
        }

        // Also update the element in allProviders but only the closest-location span
        const closestLocationElement =
          provider.querySelector(".closest-location");
        if (closestLocationElement) {
          // Use the actual address depending on if it's main location or not
          const displayAddress = closestLocation.isMainLocation
            ? mainLocationAddress
            : closestLocation.address;

          closestLocationElement.innerHTML = displayAddress;
        }
      }

      provider.dataset.distance = distance;
    });

    // remove providers that are outside of the distance

    // remove provider not in job type if not any
    if (jobTybe !== "any") {
      allProviders.filter((provider) => {
        const jobTypes = provider.dataset.jobtypes.split(",");
        return jobTypes.includes(jobTybe);
      });
    }

    // Sort providers by distance and adjust distance based on ratings in a single pass
    allProviders.forEach((provider) => {
      // Check if provider is within distance threshold
      if (provider.dataset.distance < result_distance) {
        // Check job type filtering if applicable
        if (jobTybe !== "any") {
          const jobTypes = provider.dataset.jobtypes.split(",");
          if (jobTypes.includes(jobTybe)) {
            count_within_distance++;
          }
        } else {
          count_within_distance++;
        }
        provider.classList.remove("outside-distance");
      } else {
        provider.classList.add("outside-distance");
        // Remove selected class if provider was previously selected
        if (provider.classList.contains("selected")) {
          provider.classList.remove("selected");
          document.getElementById("selected-provider").innerHTML = "";
        }
      }
    });

    // Sort providers with optimized comparisons
    allProviders.sort((a, b) => {
      // Check for outside-distance class first (most efficient)
      if (
        a.classList.contains("outside-distance") &&
        !b.classList.contains("outside-distance")
      )
        return 1;
      if (
        !a.classList.contains("outside-distance") &&
        b.classList.contains("outside-distance")
      )
        return -1;

      // Parse all values at once for better readability
      const aIsTopProvider = a.dataset.topprovider === "true";
      const bIsTopProvider = b.dataset.topprovider === "true";
      const ratingA = parseFloat(a.dataset.rating) || 0;
      const ratingB = parseFloat(b.dataset.rating) || 0;
      const reviewCountA = parseInt(a.dataset.reviewcount) || 0;
      const reviewCountB = parseInt(b.dataset.reviewcount) || 0;
      const distanceA = parseFloat(a.dataset.distance) || 0;
      const distanceB = parseFloat(b.dataset.distance) || 0;

      // Sort by top provider status
      if (aIsTopProvider && !bIsTopProvider) return -1;
      if (!aIsTopProvider && bIsTopProvider) return 1;

      // Sort by rating (higher first)
      if (ratingA > ratingB) return -1;
      if (ratingA < ratingB) return 1;

      // Sort by review count (higher first)
      if (reviewCountA > reviewCountB) return -1;
      if (reviewCountA < reviewCountB) return 1;

      // Sort by distance (lower first)
      return distanceA - distanceB;
    });

    $(".distance-count").text(count_within_distance);

    if (count_within_distance > 0) {
      $(".distance-count").addClass("visible");
    } else {
      $(".distance-count").removeClass("visible");
    }

    if (count_within_distance < 1) {
      $("#provider-list").addClass("no-results");
    } else {
      $("#provider-list").removeClass("no-results");
    }

    list.innerHTML = "";

    // if job type is selected filter the providers by job type

    var providers = allProviders;

    if ($("#job-type").val() !== "any") {
      const jobType = $("#job-type").val();

      providers = providers.filter((provider) => {
        const jobTypes = provider.dataset.jobtypes.split(",");
        return jobTypes.includes(jobType);
      });
    }

    const newProviders = providers;

    // first 10 providers class visible rest hidden
    var providerIndex = 0;
    newProviders.forEach((provider, index) => {
      // if hidden continue
      if (provider.classList.contains("outside-distance")) {
        provider.classList.remove("visible");
        provider.classList.add("hidden");

        list.appendChild(provider);

        return;
      }

      providerIndex++;

      if (providerIndex < PER_PAGE) {
        provider.classList.remove("hidden");
        provider.classList.add("visible");
        list.appendChild(provider);
      } else {
        provider.classList.remove("visible");
        provider.classList.add("hidden");
        list.appendChild(provider);
      }
    });

    // scroll to #main-search

    if (!dontScroll) {
      const mainSearch = document.getElementById("searchgroup");
      mainSearch.scrollIntoView({
        behavior: "instant",
        block: "start"
      });
    }

    setTimeout(() => {
      setLoading(false);
      refreshClosestLocation();
      updateProviderCardLinks();
    }, 500);

    // check if there are more providers to show
    showHideViewMoreButton();

    hideOutsideDistanceProvidersMarkers();
  }

  var selectFirstOnEnter = function (input) {
    // Store the original event binding function
    var _addEventListener = input.addEventListener
      ? input.addEventListener
      : input.attachEvent;

    function addEventListenerWrapper(type, listener) {
      if (type === "keydown") {
        var orig_listener = listener;
        listener = function (event) {
          var suggestion_selected =
            document.querySelector(".pac-item-selected") !== null;
          var firstSuggestion = document.querySelector(".pac-item");

          if (event.which === 13) {
            event.preventDefault();
            event.stopPropagation();

            if (!firstSuggestion) {
              // No autocomplete suggestions available
              alert(
                "No location found. Please check the spelling or select from the dropdown."
              );
              return;
            }

            if (!suggestion_selected) {
              // Simulate ArrowDown key to select the first suggestion
              var simulated_downarrow = new KeyboardEvent("keydown", {
                key: "ArrowDown",
                keyCode: 40,
                which: 40,
                bubbles: true
              });

              orig_listener.apply(input, [simulated_downarrow]);
            }
          }

          orig_listener.apply(input, [event]);
        };
      }

      _addEventListener.apply(input, [type, listener]); // Add the modified listener
    }

    if (input.addEventListener) {
      input.addEventListener = addEventListenerWrapper;
    } else if (input.attachEvent) {
      input.attachEvent = addEventListenerWrapper;
    }
  };

  function initMap($el) {
    var center = {
      lat: $el.data("lat") || 39.8283,
      lng: $el.data("lng") || -98.5795
    };
    var mapZoom = zoom;

    if (hasMapView) {
      center = {
        lat: 54.526, // A midpoint latitude between USA and Canada
        lng: -105.2551 // A midpoint longitude between USA and Canada
      };
      mapZoom = 3;
    }

    var $markers = $el.find(".marker");

    var mapArgs = {
      zoom: mapZoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: "8f3f6632debd3a28689323d0",
      // default to center of the US
      center,

      disableDefaultUI: true, // Disable all default UI
      zoomControl: true, // Enable only the zoom controls
      gestureHandling: "greedy"
    };
    map = new google.maps.Map($el[0], mapArgs);
    map.markers = [];

    map.setOptions({ minZoom: 4, maxZoom: 18 });

    const renderer = {
      render: ({ count, position, markers }) => {
        // if marker inside cluster is selected

        var icon = cluster_icon;

        if (markers.some((marker) => marker.providerId === selected)) {
          icon = cluster_icon_has_selected;
        }

        return new google.maps.Marker({
          label: {
            text: String(count),
            color: "white",
            fontSize: "14px",
            fontWeight: "bold"
          },
          position,
          icon: icon,

          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
        });
      }
    };

    if (typeof markerClusterer !== "undefined") {
      cluster = new markerClusterer.MarkerClusterer({
        map: map,
        markers: [],
        gridSize: 30,

        renderer: renderer
      });
    } else {
      console.error("MarkerClusterer library is not loaded");
    }

    $markers.each(function () {
      initMarker($(this), map);
    });

    centerMap(map);

    const options = {
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false
    };
    const input = document.getElementById("search-input");

    const autocomplete = new google.maps.places.Autocomplete(input, options);

    selectFirstOnEnter(input);

    autocomplete.addListener("place_changed", (e) => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        return;
      }

      // User has searched for a location, so this isn't a programmatic move
      programmaticMapMove = false;

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
        sortListByDistance(
          place.geometry.location.lat(),
          place.geometry.location.lng()
        );
      } else {
        sortListByDistance(
          place.geometry.location.lat(),
          place.geometry.location.lng()
        );
        map.setCenter(place.geometry.location);
      }

      // Update search state and URL
      updateSearchState();

      // log search and type if gtag present
      if (typeof gtag !== "undefined") {
        gtag("event", "search", {
          search_location: input.value
        });
      }

      // Check if location is in the US to determine units
      if (
        place.formatted_address.includes("United States") ||
        place.formatted_address.includes("USA")
      ) {
        // Set the global tracker so updateDistanceText uses miles
        isUsingUSUnits = true;
        result_distance_miles = 60;
        result_distance = Math.round(result_distance_miles / 0.621371); // Convert miles to km
      } else {
        // Not in the US, use km
        isUsingUSUnits = false;
        result_distance = 100;
        result_distance_miles = roundToNearest5(
          Math.round(result_distance * 0.621371)
        ); // Convert km to miles and round to nearest 5
      }

      // Use the centralized function to update the text
      updateDistanceText();

      setLoading(false);
      // hide the search here button
      $("#search-here").removeClass("visible");
    });

    // Update the map idle event listener
    google.maps.event.addListener(map, "idle", function () {
      handleMapInteraction();
      updateSearchState();
    });

    // Add zoom_changed event listener with improved debouncing
    google.maps.event.addListener(map, "zoom_changed", function () {
      isZooming = true;
      const newZoom = map.getZoom();

      // Only update if dynamic radius is enabled and we have a current search
      if (dynamicRadiusEnabled && current_search) {
        // Hide the circle during zooming
        if (currentSearchCircle) {
          currentSearchCircle.setMap(null);
          currentSearchCircle = null;
        }

        // Clear any existing timer
        if (zoomDebounceTimer) {
          clearTimeout(zoomDebounceTimer);
        }

        const newRadius = calculateRadiusFromZoom(newZoom);

        // Delay the actual data update
        zoomDebounceTimer = setTimeout(() => {
          isZooming = false;
          result_distance = newRadius;
          result_distance_miles = roundToNearest5(
            Math.round(newRadius * 0.621371)
          ); // Convert km to miles and round to nearest 5

          // Spread the work across multiple frames for better performance
          requestAnimationFrame(() => {
            // Update distance text in the UI
            updateDistanceText();

            // Set loading state
            setLoading(true);

            // Defer heavy processing
            setTimeout(() => {
              // Re-run the search with the new radius
              sortListByDistance(current_search.lat, current_search.lng, true);

              // Update marker visibility based on new radius
              hideOutsideDistanceProvidersMarkers();

              // Draw the circle with the final radius only after everything is done
              drawSearchCircle(
                current_search.lat,
                current_search.lng,
                result_distance,
                true
              );

              setLoading(false);

              // Update search state and history after zoom changes
              updateSearchState();
            }, 50);
          });
        }, 750); // Increased to 750ms for more stable behavior
      }
    });

    // Add event listeners to detect user-initiated map movements
    google.maps.event.addListener(map, "dragstart", function () {
      // User started dragging the map
      programmaticMapMove = false;
    });

    // Add center_changed event listener with debouncing
    let centerChangeTimer = null;
    google.maps.event.addListener(map, "center_changed", function () {
      if (programmaticMapMove) return; // Skip if this is a programmatic move

      // Clear any existing timer
      if (centerChangeTimer) {
        clearTimeout(centerChangeTimer);
      }

      // Wait for the user to stop moving the map
      centerChangeTimer = setTimeout(() => {
        const center = map.getCenter();
        current_search = {
          lat: center.lat(),
          lng: center.lng()
        };
        updateSearchState();
      }, 500);
    });

    function handleMapInteraction() {
      if (!user_interaction) {
        user_interaction = true;
        return;
      }

      if (
        !lastSearched ||
        lastSearched.lat !== map.getCenter().lat() ||
        lastSearched.lng !== map.getCenter().lng()
      ) {
        setLoading(true);

        sortListByDistance(map.getCenter().lat(), map.getCenter().lng());
        // Call refreshClosestLocation after sorting the list by distance
        refreshClosestLocation();

        lastSearched = {
          lat: map.getCenter().lat(),
          lng: map.getCenter().lng()
        };

        // Update search state and history after map movement
        updateSearchState();
      }
      user_interaction = true;
    }

    return map;
  }

  function initMarker($marker, map) {
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    const genericMarker = document.createElement("img");
    genericMarker.width = 40;
    genericMarker.height = 40;
    genericMarker.src = marker_icon;

    const providerId = $marker.data("provider");

    var marker = new google.maps.marker.AdvancedMarkerElement({
      position: latLng,
      map: map,
      content: genericMarker
    });

    marker.providerId = providerId;

    // add marker data jobtypes to the marker
    if ($marker.data("jobtypes")) {
      const jobTypes = $marker.data("jobtypes").split(",");
      marker.jobTypes = jobTypes ? jobTypes : [];
    }

    map.markers.push(marker);

    if ($marker.html()) {
      // add info window
      google.maps.event.addListener(marker, "click", function (mapsMouseEvent) {
        // set selected provider

        const lat = mapsMouseEvent.latLng.lat();
        const lng = mapsMouseEvent.latLng.lng();

        setSelectedProvider($marker.data("provider"), lat, lng);

        // infowindow.open(map, marker);
      });
    }

    cluster.addMarker(marker);

    // mapMarkers.push(marker);
  }

  function setLoading(loading) {
    if (loading) {
      $("#provider-search").addClass("loading");
    } else {
      $("#provider-search").removeClass("loading");
    }
  }

  function centerMap(map) {
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      // bounds.extend({
      //   lat: marker.position.lat(),
      //   lng: marker.position.lng()
      // });
    });

    if (map.markers.length == 1) {
      // map.setCenter(bounds.getCenter());
    } else {
      // map.fitBounds(bounds);
    }
  }

  // Load the necessary Google Maps libraries
  function loadLibraries(callback) {
    google.maps.importLibrary("maps").then(() => {
      google.maps.importLibrary("marker").then(() => {
        callback();
      });
    });
  }

  function clearSelectionOutsideDistance() {
    const markers = map.markers;
    markers.forEach((marker) => {
      if (marker.visible) {
        const distance = getDistanceFromLatLonInKm(
          current_search.lat,
          current_search.lng,
          marker.position.lat,
          marker.position.lng
        );

        if (distance > result_distance) {
          marker.visible = false;
        }
      }
    });
    const providerCards = document.querySelectorAll(".provider-card");
    providerCards.forEach((card) => {
      if (card.classList.contains("outside-distance")) {
        card.classList.remove("visible");
        card.classList.add("hidden");
      }

      if (card.classList.contains("selected")) {
        card.classList.remove("selected");
      }
    });

    reloadCluster();
  }

  function clearSelection() {
    // Reset the selected flag
    selected = null;

    // Reset all marker icons to default
    map.markers.forEach((marker) => {
      marker.content.src = marker_icon;
      // Set size back to default
      marker.content.width = 40;
      marker.content.height = 40;
      // Reset zIndex
      marker.zIndex = undefined;
    });

    // Clear selected provider element
    var selectedProvider = document.getElementById("selected-provider");
    selectedProvider.innerHTML = "";

    // Remove selected class from all provider cards
    const providerCards = document.querySelectorAll(".provider-card");
    providerCards.forEach((card) => {
      card.classList.remove("selected");
    });

    $("#selected-provider").removeClass("visible");

    // Refresh cluster to update all marker icons
    reloadCluster();
  }

  function reloadCluster() {
    // Don't reload during active zooming to prevent stuttering
    if (isZooming) return;

    cluster.clearMarkers();

    // Use batch processing for adding markers to cluster
    const visibleMarkers = map.markers.filter((marker) => marker.visible);
    const totalMarkers = visibleMarkers.length;
    const BATCH_SIZE = 50; // Process 50 markers at a time
    let processedCount = 0;

    function processBatch() {
      const endIndex = Math.min(processedCount + BATCH_SIZE, totalMarkers);

      for (let i = processedCount; i < endIndex; i++) {
        cluster.addMarker(visibleMarkers[i]);
      }

      processedCount = endIndex;

      if (processedCount < totalMarkers) {
        // Continue processing in the next frame
        requestAnimationFrame(processBatch);
      }
    }

    // Start batch processing
    if (totalMarkers > 0) {
      requestAnimationFrame(processBatch);
    }
  }

  function initProviderCards() {
    // store all providers in allProviders
    const providers = document.querySelectorAll(".provider-card");
    allProviders = Array.from(providers);
    window.allProviders = allProviders;

    // Add click handlers to provider cards
    providers.forEach((card) => {
      card.addEventListener("click", function (e) {
        if (e.target.tagName !== "A") {
          const providerId = this.dataset.provider;
          setSelectedProvider(providerId);
        }
      });
    });

    // Initial update of provider card links
    updateProviderCardLinks();
  }

  function showHideViewMoreButton() {
    const viewMoreButton = $(".load-more");
    const hiddenProviders = document.querySelectorAll(
      ".provider-card.hidden:not(.outside-distance)"
    );

    if (hiddenProviders.length > 0) {
      viewMoreButton.removeClass("hidden");

      viewMoreButton.addClass("visible");
    } else {
      viewMoreButton.removeClass("visible");
      viewMoreButton.addClass("hidden");
    }
  }

  window.showHideViewMoreButton = showHideViewMoreButton;

  function hideOutsideDistanceProvidersMarkers() {
    const markers = map.markers;
    if (!current_search || isZooming) return; // Skip during active zooming

    // Use batch processing to prevent UI freezing
    const totalMarkers = markers.length;
    const BATCH_SIZE = 50; // Process 50 markers at a time
    let processedCount = 0;

    function processBatch() {
      const endIndex = Math.min(processedCount + BATCH_SIZE, totalMarkers);

      for (let i = processedCount; i < endIndex; i++) {
        const marker = markers[i];
        // calculate distance from search
        const distance = getDistanceFromLatLonInKm(
          current_search.lat,
          current_search.lng,
          marker.position.lat,
          marker.position.lng
        );

        if (distance > result_distance) {
          marker.visible = false;
        } else {
          // if job type
          if (jobTybe !== "any") {
            if (marker.jobTypes && marker.jobTypes.includes(jobTybe)) {
              marker.visible = true;
            } else {
              marker.visible = false;
            }
          } else {
            marker.visible = true;
          }
        }
      }

      processedCount = endIndex;

      if (processedCount < totalMarkers) {
        // Continue processing in the next frame
        requestAnimationFrame(processBatch);
      } else {
        // All markers processed, reload cluster
        reloadCluster();
      }
    }

    // Start batch processing
    requestAnimationFrame(processBatch);
  }

  window.hideOutsideDistanceProvidersMarkers =
    hideOutsideDistanceProvidersMarkers;

  function setSelectedProvider(providerId, lat = false, lng = false) {
    clearSelection();
    selected = providerId;
    updateSearchState();
    updateProviderCardLinks();
    const markers = map.markers;

    const selectedMarkers = markers.filter(
      (marker) => marker.providerId === providerId
    );

    // update the icon of the selected markers
    selectedMarkers.forEach((marker) => {
      marker.content.src = marker_icon_slected;
      // set size
      marker.content.width = 60;
      marker.content.height = 60;
      // set zIndex to be above other markers
      marker.zIndex = Number(google.maps.Marker.MAX_ZINDEX) + 1;
    });

    // center the map on the selected marker
    user_interaction = false;

    // get the closest location data from the provider card
    const providerCardDetails = document.querySelector(
      `.provider-card[data-provider="${providerId}"]`
    );

    // Validate coordinates before using them
    let validLat = lat;
    let validLng = lng;

    // If lat/lng are not valid numbers, try to get them from the closest location
    if (!isValidCoordinate(lat) || !isValidCoordinate(lng)) {
      const closestLocation = providerCardDetails?.dataset?.closestlocation;
      if (closestLocation) {
        try {
          const location = JSON.parse(closestLocation);
          if (
            isValidCoordinate(location.lat) &&
            isValidCoordinate(location.lng)
          ) {
            validLat = location.lat;
            validLng = location.lng;
          }
        } catch (e) {
          console.error("Error parsing closest location:", e);
        }
      }
    }

    // If still no valid coordinates, use the first selected marker's position
    if (!isValidCoordinate(validLat) || !isValidCoordinate(validLng)) {
      if (selectedMarkers.length > 0) {
        validLat = selectedMarkers[0].position.lat;
        validLng = selectedMarkers[0].position.lng;
      }
    }

    // Set flag to indicate this is a programmatic move
    programmaticMapMove = true;

    // Only pan if we have valid coordinates
    if (isValidCoordinate(validLat) && isValidCoordinate(validLng)) {
      map.panTo({ lat: validLat, lng: validLng });
    }

    // Reset flag after a short delay to allow map to complete movement
    setTimeout(() => {
      programmaticMapMove = false;
    }, 1000);

    const providerCard = document.querySelector(
      `.provider-card[data-provider="${providerId}"]`
    );

    providerCard.classList.add("selected");

    // clone the card and append to #selected-provider
    const selectedProvider = document.getElementById("selected-provider");
    selectedProvider.innerHTML = "";

    // add close button
    const closeButton = document.createElement("button");
    closeButton.classList.add("close-button");
    closeButton.innerHTML = '<i class="far fa-times"></i>';
    closeButton.addEventListener("click", () => {
      clearSelection();
    });

    const providerCardClone = providerCard.cloneNode(true);

    providerCardClone.appendChild(closeButton);

    selectedProvider.appendChild(providerCardClone);

    $("#selected-provider").addClass("visible");

    setTimeout(() => {
      // trigger tiny zoom in
      setZoom(map.getZoom() + 0.01);
    }, 500);

    // Update provider card links after selection
    updateProviderCardLinks();
  }

  // Helper function to validate coordinates
  function isValidCoordinate(coord) {
    return typeof coord === "number" && !isNaN(coord) && isFinite(coord);
  }

  $(document).ready(function () {
    initProviderCards();
    $(".acf-map").each(function () {
      loadLibraries(() => {
        initMap($(this));

        // Check for search state in URL first
        const urlParams = new URLSearchParams(window.location.search);
        const hasMapState =
          urlParams.has("map_lat") && urlParams.has("map_lng");

        if (hasMapState) {
          // If we have a previous state, restore it immediately
          restoreSearchState();
        } else if (navigator.geolocation && !hasMapView) {
          // Only run geolocation if we don't have a previous state
          $(".search-field").addClass("geo-loading");

          navigator.geolocation.getCurrentPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };

              const geocoder = new google.maps.Geocoder();
              geocoder.geocode({ location: pos }, (results, status) => {
                if (status === "OK") {
                  if (results[0]) {
                    $("#search-input").val(
                      results[0].formatted_address
                        .split(", ")
                        .slice(-2)
                        .join(", ")
                    );
                  } else {
                    console.log("No results found");
                  }
                } else {
                  console.log("Geocoder failed due to: " + status);
                }
              });

              $(".search-field").removeClass("geo-loading");
              setTimeout(() => {
                sortListByDistance(pos.lat, pos.lng, true);
                if (!hasMapView) {
                  map.setCenter(pos);
                  setZoom(8);
                }
                $("#search-here").removeClass("visible");
              }, 500);
            },
            () => {
              $(".search-field").removeClass("geo-loading");

              console.log("User denied location access");
              if (!hasMapView) {
                map.setCenter({ lat: DEFAULT_LAT, lng: DEFAULT_LNG });
                user_interaction = true;
                current_search = { lat: DEFAULT_LAT, lng: DEFAULT_LNG };

                setZoom(4);
              }
            }
          );
        } else {
          console.log("Geolocation is not supported by this browser.");
          if (!hasMapView) {
            map.setCenter({ lat: DEFAULT_LAT, lng: DEFAULT_LNG });
            map.setZoom(DEFAULT_ZOOM);
            // Set current_search and trigger search with default coordinates
            current_search = { lat: DEFAULT_LAT, lng: DEFAULT_LNG };
            setTimeout(() => {
              sortListByDistance(DEFAULT_LAT, DEFAULT_LNG, true);
              drawSearchCircle(DEFAULT_LAT, DEFAULT_LNG, result_distance, true);
              $("#search-here").removeClass("visible");
            }, 500);
          }
        }

        // on click nothing clear selection

        google.maps.event.addListener(map, "click", () => {
          clearSelection();
        });

        // google map user initiated pan event

        function handleMapInteraction() {
          console.log("Map interaction");
          if (!user_interaction) {
            user_interaction = true;
            console.log("User interaction false");
            return;
          }

          if (
            !lastSearched ||
            lastSearched.lat !== map.getCenter().lat() ||
            lastSearched.lng !== map.getCenter().lng()
          ) {
            setLoading(true);

            sortListByDistance(map.getCenter().lat(), map.getCenter().lng());
            // Call refreshClosestLocation after sorting the list by distance
            refreshClosestLocation();

            lastSearched = {
              lat: map.getCenter().lat(),
              lng: map.getCenter().lng()
            };
          }
          user_interaction = true;
        }

        // Fire only after the user stops interacting (dragging or zooming)
        google.maps.event.addListener(map, "idle", handleMapInteraction);

        // google.maps.event.addListener(map, "center_changed", () => {
        //   // if the map center is not the last searched location

        //   if (
        //     !lastSearched ||
        //     lastSearched.lat !== map.getCenter().lat() ||
        //     lastSearched.lng !== map.getCenter().lng()
        //   ) {
        //     $("#search-here").addClass("visible");
        //   }
        // });

        // $("#search-here").click(function () {
        //   setLoading(true);
        //   // sort based on current map center
        //   sortListByDistance(map.getCenter().lat(), map.getCenter().lng());
        //   lastSearched = {
        //     lat: map.getCenter().lat(),
        //     lng: map.getCenter().lng()
        //   };
        //   // hide the search here button
        //   $(this).removeClass("visible");

        //   // update the search field

        //   updateSearchField();
        // });
      });
    });

    function updateSearchField() {
      // geocode the map center
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: map.getCenter() }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            // show postal, code, city
            $("#search-input").val(
              results[0].formatted_address.split(", ").slice(-2).join(", ")
            );

            // if in US set text to 60miles
            if (
              results[0].formatted_address.includes("United States") ||
              results[0].formatted_address.includes("USA")
            ) {
              isUsingUSUnits = true;
              result_distance_miles = 60;
              result_distance = Math.round(result_distance_miles / 0.621371); // Convert miles to km
            } else {
              isUsingUSUnits = false;
              result_distance = 100;
              result_distance_miles = roundToNearest5(
                Math.round(result_distance * 0.621371)
              ); // Convert km to miles and round to nearest 5
            }

            // Use the centralized function to update distance text
            updateDistanceText();
          } else {
            console.log("No results found");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      });
    }

    $("#view-more").click(function () {
      const list = document.getElementById("providers");
      const hiddenProviders = document.querySelectorAll(
        ".provider-card.hidden:not(.outside-distance)"
      );

      hiddenProviders.forEach((provider, index) => {
        if (index < PER_PAGE) {
          provider.classList.remove("hidden");
          provider.classList.add("visible");
          // list.appendChild(provider);
        }
      });
      showHideViewMoreButton();
    });

    $(".provider-card").click(function (e) {
      // if target not a a tag
      if (e.target.tagName !== "A") {
        clearSelection();
        const providerId = $(this).data("provider");
        setSelectedProvider(providerId);
      }
    });

    // on jobtype change filter all providers that have matching data-job-type slug matching value
    $("#job-type").change(function () {
      setLoading(true);

      jobTybe = $(this).val();

      // log search and type if gtag present
      if (typeof gtag !== "undefined") {
        gtag("event", "search", {
          search_job_type: jobTybe,
          search_location: $("#search-input").val()
        });
      }

      setTimeout(() => {
        const newjobType = $(this).val();

        if (newjobType == "any") {
          console.log("Any job type selected");
          // show all markers

          map.markers.forEach((marker) => {
            marker.visible = true;
          });

          reloadCluster();
          if (current_search) {
            sortListByDistance(current_search.lat, current_search.lng);
          } else {
            sortListByDistance(current_search);
          }

          return;
        }

        // hide markers that do not have the job type
        map.markers.forEach((marker) => {
          if (marker.jobTypes && marker.jobTypes.includes(newjobType)) {
            marker.visible = true;
          } else {
            marker.visible = false;
          }
        });

        // filer the providers by job type
        if (current_search) {
          sortListByDistance(current_search.lat, current_search.lng);
        } else {
          sortListByDistance(current_search);
        }

        reloadCluster();
        // scroll to #main-search
        const mainSearch = document.getElementById("searchgroup");
        mainSearch.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500);
    });

    // Initial update of provider card links
    updateProviderCardLinks();
  });

  // Helper function to round to nearest multiple of 5
  function roundToNearest5(num) {
    return Math.round(num / 5) * 5;
  }

  function updateSearchState() {
    if (current_search) {
      searchState.lat = current_search.lat;
      searchState.lng = current_search.lng;
      searchState.zoom = map.getZoom();
      searchState.searchTerm = $("#search-input").val();
      searchState.selectedProvider = selected;

      // Update URL with current state without reloading
      updateURLWithState();
    }
  }

  function updateURLWithState() {
    const queryParams = new URLSearchParams();
    if (searchState.lat) queryParams.append("map_lat", searchState.lat);
    if (searchState.lng) queryParams.append("map_lng", searchState.lng);
    if (searchState.zoom) queryParams.append("map_zoom", searchState.zoom);
    if (searchState.searchTerm)
      queryParams.append("map_search", searchState.searchTerm);
    if (searchState.selectedProvider)
      queryParams.append("map_provider", searchState.selectedProvider);

    const queryString = queryParams.toString();
    const newURL =
      window.location.pathname + (queryString ? "?" + queryString : "");

    // Update URL without reloading
    window.history.pushState(searchState, "", newURL);
  }

  // Add popstate event listener for back/forward navigation
  window.addEventListener("popstate", function (event) {
    if (event.state) {
      // Restore state from history
      searchState = event.state;
      if (searchState.lat && searchState.lng) {
        const position = { lat: searchState.lat, lng: searchState.lng };
        map.setCenter(position);
        if (searchState.zoom) {
          map.setZoom(searchState.zoom);
        }
        if (searchState.searchTerm) {
          $("#search-input").val(searchState.searchTerm);
        }
        current_search = position;
        user_interaction = true;
        sortListByDistance(position.lat, position.lng, true);
        if (searchState.selectedProvider) {
          setTimeout(() => {
            setSelectedProvider(
              searchState.selectedProvider,
              position.lat,
              position.lng
            );
          }, 100);
        }
      }
    }
  });

  function getSearchStateQueryString() {
    const params = new URLSearchParams();
    if (searchState.lat) params.append("map_lat", searchState.lat);
    if (searchState.lng) params.append("map_lng", searchState.lng);
    if (searchState.zoom) params.append("map_zoom", searchState.zoom);
    if (searchState.searchTerm)
      params.append("map_search", searchState.searchTerm);
    if (searchState.selectedProvider)
      params.append("map_provider", searchState.selectedProvider);
    return params.toString();
  }

  function restoreSearchState() {
    const urlParams = new URLSearchParams(window.location.search);
    const lat = urlParams.get("map_lat");
    const lng = urlParams.get("map_lng");
    const zoom = urlParams.get("map_zoom");
    const search = urlParams.get("map_search");
    const provider = urlParams.get("map_provider");

    if (lat && lng) {
      const position = { lat: parseFloat(lat), lng: parseFloat(lng) };

      // Set the map position first
      map.setCenter(position);
      if (zoom) {
        map.setZoom(parseInt(zoom));
      }

      // Update the search input if we have a search term
      if (search) {
        $("#search-input").val(search);
      }

      // Set the current search state
      current_search = position;
      user_interaction = true;

      // Sort the list and restore the selected provider
      sortListByDistance(position.lat, position.lng, true);

      if (provider) {
        // Wait for the list to be sorted before selecting the provider
        setTimeout(() => {
          setSelectedProvider(provider, position.lat, position.lng);
        }, 100);
      }
    }
  }

  function updateProviderCardLinks() {
    const queryParams = new URLSearchParams();
    if (searchState.lat) queryParams.append("map_lat", searchState.lat);
    if (searchState.lng) queryParams.append("map_lng", searchState.lng);
    if (searchState.zoom) queryParams.append("map_zoom", searchState.zoom);
    if (searchState.searchTerm)
      queryParams.append("map_search", searchState.searchTerm);
    if (searchState.selectedProvider)
      queryParams.append("map_provider", searchState.selectedProvider);

    const queryString = queryParams.toString();

    // Update all provider card links
    document
      .querySelectorAll(".provider-card .button.secondary")
      .forEach((link) => {
        const baseUrl = link.getAttribute("href").split("?")[0];
        link.setAttribute(
          "href",
          baseUrl + (queryString ? "?" + queryString : "")
        );
      });
  }
})(jQuery);
